import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { TextCellData } from "@/utils/CellsFactory";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import { useCopyText } from "@/utils/copyText";

interface Props {
    value?: string | number | boolean | object;
    item?: any;
    data: TextCellData
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextCell',
  props: {
    value: { type: [String, Number, Boolean, Object] },
    item: null,
    data: null
  },
  setup(__props: any) {

const props = __props as {
    value?: string | number | boolean | object;
    item?: any;
    data: TextCellData
}


const tooltipComp = ref(null);

const getClasses = computed(() => {
    const classes = {
        [`--${getColor.value}`]: !!getColor.value,
        '--clamp': props.data.clamp,
        '--link': props.data.isLink,
        '--pointer': isShowTooltip.value,
        '--break-all': props.data.isWordBreakAll,
    };
    return Object.keys(classes).filter((key) => classes[key]).join(' ');
});

const getColor = computed(() => {
    if (typeof props.data.color === 'function') {
        return props.data.color(props.item);
    }
    return props.data.color;
});

const getWrapStyle = computed(() => {
    if (props.data.clamp) {
        return 'max-width: 100%; min-width: 0; width: 100%';
    }
    if (props.data.tooltip) {
        return 'width: fit-content';
    }
    return '';
});

const getStyle = computed(() => {
    const clamp = `-webkit-line-clamp: ${props.data.clamp}`;
    return `${clamp}`;
});

const getValue = computed(() => {
    if (props.data.template) {
        return props.data.template(props.item);
    }
    return props.value ? String(props.value) : '';
});

const textCell = ref(null);
const textCellWrap = ref(null);

const isShowTooltip = computed(() => {
    const isTooltip = !!props.data.tooltip;
    const isClamp = !!props.data.clamp;
    if (!isClamp) return isTooltip;

    const textWidth = textCell.value ? textCell.value.offsetWidth : 0;
    const textWrapWidth = textCellWrap.value ? textCellWrap.value.offsetWidth : 0;
    const isShow = textWidth >= textWrapWidth;
    return isTooltip || isShow;
});

const tooltipText = ref('');
const setTooltipText = () => {
    if (!isShowTooltip.value || tooltipText.value.length > 0) return;
    if (typeof props.data.tooltip === 'function') {
        tooltipText.value = props.data.tooltip(props.item);
    } else if (typeof props.data.tooltip === 'string') {
        tooltipText.value = props.data.tooltip;
    } else {
        tooltipText.value = getValue.value;
    }
};

const getIcon = computed(() => {
    if (!props.data.icon) return null;
    if (typeof props.data.icon === 'function') return props.data.icon(props.item);
    return props.data.icon;
});

const copy = () => {
    if (!props.data.isCopyOnClick) return;
    useCopyText(getValue.value, 'Скопировано');
};


return { __sfc: true,props, tooltipComp, getClasses, getColor, getWrapStyle, getStyle, getValue, textCell, textCellWrap, isShowTooltip, tooltipText, setTooltipText, getIcon, copy, BaseTooltip }
}

})